export default __webpack_public_path__ + "static/O0154-9bc5498241df5f988fb27fd435781daf.png";